import * as THREE from 'three';
import type {
  ExtrudeHandleRole,
  ExtrudeHandleSide,
} from '@/composables/extrude-direction-drag-state';

/**
 * 拉伸手柄部件类型。
 */
export type ExtrudeGizmoPartKind =
  /** 轴体。 */
  | 'shaft'
  /** 正向主手柄。 */
  | 'positivePrimaryHead'
  /** 反向主手柄。 */
  | 'negativePrimaryHead'
  /** 正向次手柄。 */
  | 'positiveSecondaryHead'
  /** 反向次手柄。 */
  | 'negativeSecondaryHead';

/**
 * 拉伸手柄部件分组对象。
 *
 * 设计说明：
 * 1. 使用显式类成员保存部件语义，避免继续通过隐式标签传播 `kind/side/role`；
 * 2. 选择与拖拽链可以直接根据实例类型和成员读取语义；
 * 3. `skipSelection` 作为明确能力保留，后续若要扩展统一选择过滤器，可直接读取该成员。
 */
export class ExtrudeHandlePartGroup extends THREE.Group {
  /** 运行时类型标记。 */
  public readonly isExtrudeHandlePartGroup = true;

  /** 部件类型。 */
  public readonly partKind: ExtrudeGizmoPartKind;

  /** 部件所在侧。 */
  public readonly side: ExtrudeHandleSide | null;

  /** 部件角色。 */
  public readonly role: ExtrudeHandleRole | null;

  /** 是否跳过常规选择链。 */
  public readonly skipSelection = true;

  /**
   * 构造函数。
   *
   * @param input 构造输入。
   */
  public constructor(input: {
    partKind: ExtrudeGizmoPartKind;
    side: ExtrudeHandleSide | null;
    role: ExtrudeHandleRole | null;
  }) {
    super();
    this.partKind = input.partKind;
    this.side = input.side;
    this.role = input.role;
  }
}
